export default __webpack_public_path__ + "static/media/warley.c9a9ae67.svg";